/**
 * @author Goutam Shetty <goutam.shetty@314ecorp.com>
 * @description Mac-like scrollbar behavior utility
 */

const scrollTimeouts = new WeakMap<HTMLElement, NodeJS.Timeout>();

const isMac = () => {
	return /Mac|iPhone|iPad|iPod/.test(navigator.userAgent);
};

const handleScroll = (event: Event) => {
	const target = event.target;
	if (!target || !(target instanceof HTMLElement)) {
		return;
	}

	target.classList.add('scrolling');

	const existingTimeout = scrollTimeouts.get(target);
	if (existingTimeout) {
		clearTimeout(existingTimeout);
	}

	const timeout = setTimeout(() => {
		target.classList.remove('scrolling');
		scrollTimeouts.delete(target);
	}, 1000);

	scrollTimeouts.set(target, timeout);
};

const initializeMacScrollbarBehavior = (): void => {
	if (isMac()) {
		document.body.classList.add('platform-mac');
		return;
	}

	document.body.classList.add('platform-windows');
	document.addEventListener('scroll', handleScroll, true);
};

export default initializeMacScrollbarBehavior;
